import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';
import { rOyakKiraBilgileriYillarWrapper } from '../../../../api/models/.catalog';

export default ApiBaseReducer<
  pList,
  IInputDataStateModel<pList, rOyakKiraBilgileriYillarWrapper>,
  rOyakKiraBilgileriYillarWrapper
>(
  ActionSubTypes.API_OYAKKIRATRGENELIYILLIKGELIRDAGILIMILISTELE,
  DefaultInputDataStateModel<pList, rOyakKiraBilgileriYillarWrapper>()
);
